<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";
import Password from "@/components/widgets/input-password";

export default {
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      language: "en",

      personNumberMask: "###.###.###-##",
      personNumber: "",
      password: "",

      loading: false,
      submitted: false,

      user: {
        name: "",
        personNumber: "",
        avatar: "",
      },
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  validations: {
    personNumber: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { personNumber, password } = this;
        if (personNumber && password) {
          this.alert.type = "";
          this.alert.message = "";
          this.loading = true;
          this.$v.$reset();
          this.login({ personNumber, password });
        }
      }
    },
    clearUser() {
      this.personNumber = "";
      this.user.name = "";
      this.user.personNumber = "";
      this.user.avatar = "";
    },
  },
  mounted() {
    if (this.$store.state.account.user) {
      this.personNumber = this.$store.state.account.user.personNumber;
      this.user.name = this.$store.state.account.user.name;
      this.user.personNumber = this.$store.state.account.user.personNumber;
      this.user.avatar = this.$store.state.account.user.avatar;
    }
  },
  watch: {
    "alert.type": function (alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
    personNumber(value) {
      if (value.length <= 14) {
        this.personNumberMask = '###.###.###-##';
      } else {
        this.personNumberMask = '##.###.###/####-##';
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-2 text-center">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 200px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <b-form @submit.prevent="handleSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ alert.message }}
            </div>
            <b-form-group label="CPF/CNPJ" label-for="personNumber">
              <b-form-input v-model="personNumber" type="text" inputmode="numeric" :class="{ 'is-invalid': submitted && $v.personNumber.$error }" v-mask="personNumberMask"></b-form-input>
              <div v-if="submitted && !$v.personNumber.required" class="invalid-feedback">
                O CPF/CNPJ é obrigatório
              </div>
            </b-form-group>
            <b-form-group label="Senha" label-for="password">
              <Password v-model="password" :v="$v.password"></Password>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                Entrar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </div>
          </b-form>
          <div class="text-center py-5">
            <div>
              <router-link tag="a" to="/password-forgot" class="text-muted">
                <i class="mdi mdi-lock mr-1"></i>
                Esqueceu sua senha?
              </router-link>
            </div>
            <div class="mt-4">
              Não possui uma conta?
              <router-link tag="a" to="/register" class="d-block btn btn-outline-default btn-lg btn-block mt-2">Cadastre-se</router-link>
            </div>
            <Languages class="d-none" type="dropup"></Languages>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>